export const MAX_ALLOWED_UPLOAD_SIZE = 250 * 1024 * 1024; //250MB
